import Leaflet from 'leaflet';
import { getRoofColor } from '__editor/components/roofsSelector/components/roofsSelectorDrawingManager/roofsSelectorDrawingManagerHelper';

export function getBingPolyRoofEdge(coords: { lat: number, lng: number}[], roofId?: number) {
  const roofColor = getRoofColor(roofId);
  return Leaflet.polyline(coords, { color: roofColor, weight: 10 });
}
